import { FC } from 'react'
import { Button, ButtonProps } from 'rsuite'

import styles from '../../../styles/Banner.module.less'
import buttonStyles from '../../../styles/CustomButtons.module.less'

const MarketingBannerButtonBase: FC<ButtonProps> = (props) => {
  const { children, className = '', appearance = 'ghost', ...rest } = props

  const linkClassName = `${className}
                        margin-top-spacer-double
                        ${buttonStyles['custom-button']}
                        ${buttonStyles['button-base-font-family']}
                        ${buttonStyles['button-caret']}
                        ${buttonStyles['button-tertiary']}
                      `

  const buttonClassName = `${className} margin-top-spacer-double ${styles['cta-button']}`

  return (
    <Button
      className={appearance === 'link' ? linkClassName : buttonClassName}
      appearance={appearance}
      {...rest}
    >
      {children}
    </Button>
  )
}

export default MarketingBannerButtonBase
